module.exports = __webpack_public_path__ + "static/media/no-results.25387835.svg";